var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5C8.65 24.5 5.8125 23.3375 3.4875 21.0125C1.1625 18.6875 0 15.85 0 12.5C0 9.15 1.1625 6.3125 3.4875 3.9875C5.8125 1.6625 8.65 0.5 12 0.5C13.725 0.5 15.375 0.856 16.95 1.568C18.525 2.28 19.875 3.299 21 4.625V0.5H24V11H13.5V8H19.8C19 6.6 17.906 5.5 16.518 4.7C15.13 3.9 13.624 3.5 12 3.5C9.5 3.5 7.375 4.375 5.625 6.125C3.875 7.875 3 10 3 12.5C3 15 3.875 17.125 5.625 18.875C7.375 20.625 9.5 21.5 12 21.5C13.925 21.5 15.6625 20.95 17.2125 19.85C18.7625 18.75 19.85 17.3 20.475 15.5H23.625C22.925 18.15 21.5 20.3125 19.35 21.9875C17.2 23.6625 14.75 24.5 12 24.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.38f576f93a197ceef0c7524f2c4a2cbf.svg";
export { ForwardRef as ReactComponent };